<template>
  <div style="width: 200px">
    <label for="up-image" class="control-label"
      >{{ title | setText(title) }} -
      <span @click="clear" class="text-success link">
        {{ "upload" | setText("Загрузить") }}</span
      ></label
    >
    <div class="draw-image_fix">
      <img :src="value ? value : noImage" alt="" />
      <input
        id="up-image"
        ref="fileupload"
        accept="image/*"
        type="file"
        @change="handleFileUpload"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: ["title", "value"],
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (file.size > 1048576) {
          this.$notify({
            title: "ERROR",
            message: "MAX FILE SIZE 1 MB",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          try {
            let MAX_WIDTH = 768;
            let img = document.createElement("img");
            img.src = reader.result;
            img.onload = () => {
              let canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;
              let newHeight = height;
              let newWidth = width;
              let ctx = canvas.getContext("2d");
              if (width > MAX_WIDTH) {
                newHeight = (MAX_WIDTH * height) / width;
                newWidth = MAX_WIDTH;
              }
              canvas.height = newHeight;
              canvas.width = newWidth;
              ctx.drawImage(img, 0, 0, newWidth, newHeight);

              this.$emit("input", canvas.toDataURL("image/png"));
            };
          } catch (e) {
            this.$emit("input", reader.result);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.draw-image_fix {
  cursor: pointer;
  position: relative;
  height: 0;
  max-width: 100%;
  width: 200px;
  padding-top: 100%;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-bottom: 30px;

  input {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  img {
    z-index: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;
    width: 90%;
    height: 90%;
  }
}
</style>
